// extracted by mini-css-extract-plugin
export var chevronIcon = "_sq-1";
export var edgeToggle = "_sq-0";